var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import ES6Set from './utils/set';
import EventHandle from './event/EventHandle';
import EventFul from './utils/Eventful';
import Group from './shapes/Group';
import { getRequestAnimationFrame, getCancelAnimationFrame } from './utils/rAF';
import { addContext, removeContext } from './utils/measureText';
import { getPainter, registerPainter } from './painter';
import CanvasPainter from './painter/CanvasPainter';
import SVGPainter from './painter/SVGPainter';
import { renderToSVGString } from './svg/renderToSVGString';
import { downloadBase64 } from './utils/download';
import { getDomContentSize } from './utils/dom';
import { getFeature } from './utils/featureManager';
registerPainter('canvas', CanvasPainter);
registerPainter('svg', SVGPainter);
var Render = /** @class */ (function (_super) {
    __extends(Render, _super);
    function Render(dom, option) {
        if (option === void 0) { option = {}; }
        var _this = _super.call(this) || this;
        _this.dpr = 1;
        _this.enableDirtyRect = true;
        _this.maxDirtyRects = 128;
        // public showDirtyRect: boolean = false;
        _this.simulateClickEvent = false;
        _this.showBoundingRect = false;
        _this.showBBox = false;
        _this.showFPS = false;
        _this.scaleByDprBeforePaint = true;
        _this.enableViewportCulling = false;
        _this.chunksElement = new ES6Set();
        _this._needUpdate = true;
        _this._eventGroop = new Group();
        _this._dirtyElements = new ES6Set();
        _this._frameAbleElement = new ES6Set();
        _this._disposed = false;
        _this._isOnframe = false;
        _this._onFrame = function (now) {
            var _a;
            if (_this._disposed || _this._isOnframe) {
                return;
            }
            _this._requestAnimationFrameId = null;
            _this._isOnframe = true;
            _this._frameAbleElement.forEach(function (item) { return item.onFrame(now); });
            _this._eventHandle.onFrame();
            _this._eventElementHandle.onFrame();
            if (_this._workerEnabled) {
                var canvas = _this._painter.getCanvas();
                _this._commandBuffer.start(canvas.width, canvas.height);
            }
            (_a = _this._painter) === null || _a === void 0 ? void 0 : _a.onFrame(now);
            if (_this._workerEnabled) {
                _this._commandBuffer.commit();
            }
            _this._needUpdate = false;
            _this._dirtyElements.clear();
            var chunkSize = _this.chunksElement.size;
            var frameAbleSize = _this._frameAbleElement.size;
            if (chunkSize === 0 && frameAbleSize === 0) {
                var currentTime = typeof window !== 'undefined' && window.performance && window.performance.now
                    ? window.performance.now()
                    : Date.now();
                var timeRemaining = 16 - (currentTime - now);
                if (timeRemaining > 5) {
                    _this._rootGroup.getBoundingClientRect();
                }
            }
            _this._isOnframe = false;
            if (frameAbleSize > 0 || chunkSize > 0) {
                _this.nextTick();
            }
        };
        _this._onThreadPaited = function (data, clearRects) {
            var painter = _this._painter;
            var ctx = painter.getCanvasContext();
            clearRects.forEach(function (rect) { return ctx.clearRect(rect.x, rect.y, rect.width, rect.height); });
            ctx.drawImage(data, 0, 0, data.width, data.height);
        };
        _this._rootGroup = new Group();
        _this._rootGroup.ownerRender = _this;
        _this._isBrowser = /html.*?element/gi.test(Object.prototype.toString.call(dom));
        _this.dpr = option.dpr || (_this._isBrowser ? window.devicePixelRatio || 1 : 1);
        _this._renderer = option.renderer || 'canvas';
        _this._workerEnabled = option.workerEnabled;
        _this._dom = dom;
        if (dom) {
            var domWidth = void 0;
            var domHeight = void 0;
            if (typeof dom.getContext === 'function' && !_this._isBrowser) {
                domWidth = dom.width;
                domHeight = dom.height;
            }
            else {
                var _a = getDomContentSize(dom), divWidth = _a[0], divHeight = _a[1];
                domWidth = divWidth;
                domHeight = divHeight;
            }
            var _b = option.width, width = _b === void 0 ? domWidth : _b, _c = option.height, height = _c === void 0 ? domHeight : _c;
            _this._width = width;
            _this._height = height;
            var UsedPainter = getPainter(_this._renderer) || CanvasPainter;
            if (UsedPainter === CanvasPainter) {
                _this._renderer = 'canvas';
            }
            _this._painter = new UsedPainter(_this);
            addContext(_this._painter.getContext());
        }
        else {
            _this._width = option.width || 300;
            _this._height = option.height || 150;
        }
        _this._eventHandle = new EventHandle(_this);
        _this._eventElementHandle = new EventHandle(_this, true);
        if (_this._workerEnabled &&
            _this.renderer === 'canvas' &&
            _this._isBrowser &&
            window.OffscreenCanvas &&
            getFeature('worker')) {
            var _d = getFeature('worker')().getRaf({
                onPainted: _this._onThreadPaited,
            }), raf = _d.requestAnimationFrame, caf = _d.cancelAnimationFrame, unRegisterTask = _d.unRegisterTask, commandBuffer = _d.commandBuffer;
            _this._raf = raf;
            _this._caf = caf;
            _this._unregisterWorker = unRegisterTask;
            _this._commandBuffer = commandBuffer;
            _this._painter.setContext(commandBuffer);
        }
        else {
            _this._workerEnabled = false;
            _this._raf = getRequestAnimationFrame();
            _this._caf = getCancelAnimationFrame();
        }
        _this.nextTick();
        return _this;
    }
    Render.prototype.resize = function (width, height) {
        var _a;
        this._width = width;
        this._height = height;
        (_a = this._painter) === null || _a === void 0 ? void 0 : _a.resize(width, height);
        this.dispatch('resize');
    };
    Render.prototype.getRaf = function () {
        return this._raf;
    };
    Render.prototype.isWorkerEnabled = function () {
        return this._workerEnabled;
    };
    Render.prototype.refresh = function () {
        this._needUpdate = true;
        this.nextTick();
    };
    Render.prototype.refreshImmediately = function () {
        this._needUpdate = true;
        this._onFrame();
    };
    Render.prototype.dirty = function (el) {
        this.nextTick();
        this._needUpdate = true;
        if (el && this._renderer === 'svg') {
            this._dirtyElements.add(el);
            return;
        }
        if (el && el.isClip) {
            this._rootGroup.dirtyClipTarget(el);
            return;
        }
        if (el && this.enableDirtyRect && this._dirtyElements.size <= this.maxDirtyRects) {
            this._dirtyElements.add(el);
        }
    };
    Render.prototype.getWidth = function () {
        return this._width;
    };
    Render.prototype.getHeight = function () {
        return this._height;
    };
    Object.defineProperty(Render.prototype, "renderer", {
        get: function () {
            return this._renderer;
        },
        enumerable: true,
        configurable: true
    });
    Render.prototype.prepend = function (element) {
        this._rootGroup.prepend(element);
    };
    Render.prototype.add = function (element) {
        this._rootGroup.add(element);
    };
    Render.prototype.addAll = function (elements) {
        this._rootGroup.addAll(elements);
    };
    Render.prototype.remove = function (element) {
        this._rootGroup.remove(element);
    };
    Render.prototype.clear = function () {
        this._rootGroup.clear();
    };
    Render.prototype.updateAll = function (elements, transition) {
        if (transition === void 0) { transition = true; }
        this.chunksElement.clear();
        this._frameAbleElement.clear();
        this._rootGroup.updateAll(elements, transition);
    };
    Render.prototype.addEventElement = function (element) {
        this._eventGroop.add(element);
    };
    Render.prototype.removeEventElement = function (element) {
        this._eventGroop.remove(element);
    };
    Render.prototype.getDom = function () {
        return this._dom;
    };
    Render.prototype.getRoot = function () {
        return this._rootGroup;
    };
    Render.prototype.getEventGroup = function () {
        return this._eventGroop;
    };
    Render.prototype.getDirtyElements = function () {
        return this._dirtyElements;
    };
    Render.prototype.downloadImage = function (name) {
        var base64 = this.getPainter().getBase64();
        downloadBase64(base64, name);
    };
    Render.prototype.needUpdate = function () {
        return this._needUpdate;
    };
    Render.prototype.dispose = function () {
        // todo polyfill
        this._caf(this._requestAnimationFrameId);
        if (this._workerEnabled) {
            this._unregisterWorker();
        }
        if (this._painter) {
            removeContext(this._painter.getContext());
            this._painter.dispose();
        }
        this.removeAllListeners();
        this._eventHandle.dispose();
        this._eventElementHandle.dispose();
        this._frameAbleElement.clear();
        this.chunksElement.clear();
        this._rootGroup.clear();
        this._eventGroop.clear();
        this._rootGroup = null;
        this._dom = undefined;
        this._disposed = true;
    };
    Render.prototype.isBrowser = function () {
        return this._isBrowser;
    };
    Render.prototype.getPainter = function () {
        return this._painter;
    };
    Render.prototype.renderToSVGString = function (option) {
        if (option === void 0) { option = {}; }
        return renderToSVGString(this.getRoot(), this._width, this._height, option.figma);
    };
    Render.prototype.syntheticEvent = function (type, param) {
        this._eventHandle.dispatch(type, param);
        this._eventElementHandle.dispatch(type, param);
    };
    Render.prototype.getEventHandle = function () {
        return this._eventHandle;
    };
    Render.prototype.__addFrameableElement = function (element) {
        this._frameAbleElement.add(element);
        this.nextTick();
    };
    Render.prototype.__removeFrameableElement = function (element) {
        this._frameAbleElement.delete(element);
    };
    Render.prototype.onEvent = function (type) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        if (this.eventListener) {
            this.eventListener.call(null, type, params);
        }
    };
    Render.prototype.nextTick = function () {
        if (!this._requestAnimationFrameId) {
            this._requestAnimationFrameId = this._raf(this._onFrame);
        }
    };
    Render.prototype.getOneChunk = function () {
        var parent;
        var items;
        if (!this.chunksElement.size) {
            return;
        }
        this.chunksElement.forEach(function (group) {
            if (!parent) {
                parent = group;
                items = group.getChunks()[0];
            }
        });
        return {
            parent: parent,
            items: items,
        };
    };
    return Render;
}(EventFul));
export default Render;
